export const AUTH_TYPE = {
  LOGIN: "login",
  SIGNUP: "signup",
};

export const CONTACT_URL = 'https://montycloud.com/demo_request';
